import { Routes, RouterModule } from '@angular/router';

const expTypeRoutes: Routes = [
];

export const ExpTypeExtRouter = RouterModule.forChild(expTypeRoutes);